import { render, staticRenderFns } from "./BankAgreement.vue?vue&type=template&id=5282cab8&scoped=true&"
import script from "./BankAgreement.vue?vue&type=script&lang=js&"
export * from "./BankAgreement.vue?vue&type=script&lang=js&"
import style0 from "./BankAgreement.vue?vue&type=style&index=0&id=5282cab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282cab8",
  null
  
)

export default component.exports